import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Loader2, Eye, Users, Sparkles, TrendingUp } from "lucide-react";

const Bars = ({ data, keyName, color }) => {
  const max = Math.max(1, ...data.map((d) => d[keyName]));
  return (
    <div className="flex items-end gap-1.5 h-40">
      {data.map((d) => (
        <div key={d.date} className="flex-1 flex flex-col items-center gap-1 group">
          <div className="w-full rounded-t transition-all relative" style={{ height: `${(d[keyName] / max) * 100}%`, minHeight: d[keyName] > 0 ? 4 : 0, background: color }}>
            <span className="absolute -top-5 left-1/2 -translate-x-1/2 text-[10px] text-white opacity-0 group-hover:opacity-100 transition">{d[keyName]}</span>
          </div>
          <span className="text-[9px] text-slate-500">{d.date.slice(5)}</span>
        </div>
      ))}
    </div>
  );
};

const StatCard = ({ icon: Icon, label, value, accent }) => (
  <div className="rounded-2xl border border-white/10 bg-[#0e2740] p-5">
    <div className="flex items-center justify-between"><span className="text-slate-400 text-sm">{label}</span><span className="rounded-lg p-2" style={{ background: `${accent}22`, color: accent }}><Icon className="h-5 w-5" /></span></div>
    <p className="font-display text-4xl text-white mt-2">{value}</p>
  </div>
);

const AdminOverview = ({ onGoLeads }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.analytics().then(setData).catch(() => setData(null)); }, []);
  if (!data) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#f5a524]" /></div>;
  return (
    <div>
      <h1 className="font-display text-3xl text-white mb-1">Dashboard Overview</h1>
      <p className="text-slate-400 text-sm mb-6">Day-to-day activity for the last 14 days.</p>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-6">
        <StatCard icon={Eye} label="Page views (14d)" value={data.total_views} accent="#1c6ba3" />
        <StatCard icon={Users} label="Total leads" value={data.total_leads} accent="#0e9488" />
        <button onClick={onGoLeads} className="text-left"><StatCard icon={Sparkles} label="New leads" value={data.new_leads} accent="#f5a524" /></button>
        <StatCard icon={TrendingUp} label="Top page" value={data.top_pages[0]?.path === "/" ? "Home" : (data.top_pages[0]?.path?.split("/").pop() || "—")} accent="#a855f7" />
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-2xl border border-white/10 bg-[#0e2740] p-5"><h3 className="font-heading text-lg text-white mb-4">Daily page views</h3><Bars data={data.views_series} keyName="views" color="#1c6ba3" /></div>
        <div className="rounded-2xl border border-white/10 bg-[#0e2740] p-5"><h3 className="font-heading text-lg text-white mb-4">Daily leads</h3><Bars data={data.leads_series} keyName="leads" color="#f5a524" /></div>
      </div>
      <div className="grid gap-4 lg:grid-cols-2 mt-4">
        <div className="rounded-2xl border border-white/10 bg-[#0e2740] p-5">
          <h3 className="font-heading text-lg text-white mb-4">Top pages</h3>
          <div className="space-y-2">{data.top_pages.map((p) => (<div key={p.path} className="flex justify-between text-sm border-b border-white/5 pb-2"><span className="text-slate-300 truncate">{p.path}</span><span className="text-[#f5a524] font-semibold">{p.views}</span></div>))}{data.top_pages.length===0&&<p className="text-slate-500 text-sm">No data yet.</p>}</div>
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#0e2740] p-5">
          <h3 className="font-heading text-lg text-white mb-4">Lead sources</h3>
          <div className="space-y-2">{data.lead_sources.map((s) => (<div key={s.source} className="flex justify-between text-sm border-b border-white/5 pb-2"><span className="text-slate-300 capitalize">{s.source}</span><span className="text-[#0e9488] font-semibold">{s.count}</span></div>))}{data.lead_sources.length===0&&<p className="text-slate-500 text-sm">No leads yet.</p>}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminOverview;
